// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pEGiZSrZUV8e79dDcjmQ {
  padding-bottom: 20px;
}

.pEGiZSrZUV8e79dDcjmQ > div:first-of-type {
  padding-bottom: 6px;
}

.XTh2bjlNaccupXFRX9LX {
  display: flex;
  flex-direction: column;
  max-width: 699px;
  margin: 24px auto 20px auto;
  background-color: var(--color-white);
  min-height: 85px;
  border-radius: 12px;
  padding: 30px;
  box-shadow: var(--box-shadow);
}

.dU8eXXzqOWJvFL5CU8Qi {
  display: flex;
  justify-content: flex-end;
  padding-top: 20px;
}

.oTNrnR6KE65Zd5CYr5QF {
  padding: 20px 0;
}

.dU8eXXzqOWJvFL5CU8Qi button {
  margin-right: unset;
}

.SmOQmxGKU6dshRFcpwA6 {
  margin-left: 20px;
}

.Ih8dqQ1eCRvd2Q4FCzWd {
  display: flex;
  min-height: 66px;
  padding: 20px 10px;
}

.IP1hOmpRGYgc72g4IPIy {
  margin: 10px;
}

.XD1YDtQPjEXHQdswwNAi label {
  margin-bottom: 20px;
}

.XD1YDtQPjEXHQdswwNAi span {
  border-color: var(--color-light-green);
}

.bETN9f25LZ6XSo8Fz1gO {
  margin: 25px 0px;
}
`, "",{"version":3,"sources":["webpack://./src/App/views/CoordinatorData/CoordinatorData.module.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,2BAA2B;EAC3B,oCAAoC;EACpC,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".title {\n  padding-bottom: 20px;\n}\n\n.title > div:first-of-type {\n  padding-bottom: 6px;\n}\n\n.schools {\n  display: flex;\n  flex-direction: column;\n  max-width: 699px;\n  margin: 24px auto 20px auto;\n  background-color: var(--color-white);\n  min-height: 85px;\n  border-radius: 12px;\n  padding: 30px;\n  box-shadow: var(--box-shadow);\n}\n\n.buttons {\n  display: flex;\n  justify-content: flex-end;\n  padding-top: 20px;\n}\n\n.error {\n  padding: 20px 0;\n}\n\n.buttons button {\n  margin-right: unset;\n}\n\n.buttonFinish {\n  margin-left: 20px;\n}\n\n.schoolLevels {\n  display: flex;\n  min-height: 66px;\n  padding: 20px 10px;\n}\n\n.errorMessage {\n  margin: 10px;\n}\n\n.checkboxGroup label {\n  margin-bottom: 20px;\n}\n\n.checkboxGroup span {\n  border-color: var(--color-light-green);\n}\n\n.hrPrimary {\n  margin: 25px 0px;\n}\n\n:export {\n  green: var(--color-light-green);\n  grey: var(--color-grey);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"green": `var(--color-light-green)`,
	"grey": `var(--color-grey)`,
	"title": `pEGiZSrZUV8e79dDcjmQ`,
	"schools": `XTh2bjlNaccupXFRX9LX`,
	"buttons": `dU8eXXzqOWJvFL5CU8Qi`,
	"error": `oTNrnR6KE65Zd5CYr5QF`,
	"buttonFinish": `SmOQmxGKU6dshRFcpwA6`,
	"schoolLevels": `Ih8dqQ1eCRvd2Q4FCzWd`,
	"errorMessage": `IP1hOmpRGYgc72g4IPIy`,
	"checkboxGroup": `XD1YDtQPjEXHQdswwNAi`,
	"hrPrimary": `bETN9f25LZ6XSo8Fz1gO`
};
export default ___CSS_LOADER_EXPORT___;
